exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{position:absolute;top:0;width:100%;height:100%}.background{position:fixed;z-index:300;left:0;top:0;width:100vw;height:100vh;opacity:.5;background-color:#000}", ""]);

// exports
